import {useMutation} from '@tanstack/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {postConfirmRegistrationData} from '../../services/postConfirmRegistrationData';
import {useRegistrationUpdateStatusStore} from 'presentation/pages/private/store/useRegistrationUpdateStatusStore';
import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

export const usePostConfirmRegistrationDataMutation = () => {
	const {setNeedsUpdate} = useRegistrationUpdateStatusStore();

	return useMutation({
		mutationKey: [MUTATION_KEYS.CONFIRM_REGISTRATION_DATA],
		mutationFn: postConfirmRegistrationData,
		onSuccess: () => {
			queryClient.setQueryData([QUERY_KEYS.REGISTRATION_UPDATE_STATUS], {
				necessitaAtualizacao: false,
			});
			setNeedsUpdate(false);
		},
	});
};
